module.exports = {
  NOT_ALLOWED: 'NOT_ALLOWED',
  IS_ALLOWED: 'IS_ALLOWED'
};



// WEBPACK FOOTER //
// ./src/const/TicketChangeType.js